import { AxiosError } from 'axios';
import { ConfigurationType } from 'web-library/models/DropDown';
import { GET_PROFILE_AMENDMENT_REQUEST_FILTER_URL } from '../../constants/apiUrls';
import { GET_PROFILE_AMENDMENT_REQUEST_FILTER_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================
interface ProfileAmendmentRequestFilterResponse {
  status: ConfigurationType[];
}

interface Input {
  onSuccess?: (res: ProfileAmendmentRequestFilterResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

// =============================================================================
// Query
// =============================================================================

export const useGetProfileAmendmentRequestFilter = ({ onError, onSuccess }: Input = {}) => {
  const getProfileAmendmentRequestFilter = async () => {
    const res = await axiosClient.get<ProfileAmendmentRequestFilterResponse>(
      GET_PROFILE_AMENDMENT_REQUEST_FILTER_URL
    );
    return res.data;
  };

  return useCustomQuery(
    GET_PROFILE_AMENDMENT_REQUEST_FILTER_QUERY_KEY,
    getProfileAmendmentRequestFilter,
    {
      onSuccess,
      onError,
    }
  );
};
